/* =====================================================================
   juizs-ingredient-modal.js — OD-001
   ---------------------------------------------------------------------
   Leest de JSON-eilanden uit `snippets/juizs-ingredient-modal.liquid`
   (één per variant met dagschema) en vult de modal.

   Hergebruikt `window.JuizsOverlay` uit assets/juizs-cart.js: dezelfde
   focus-trap, Esc-afhandeling en scroll-lock als de winkelwagen-lade.

   Triggers, waar dan ook in de pagina:
     [data-juizs-juice="<handle>"]          → opent dat sapje
     [data-juizs-juice-variant="<id>"]      → optioneel: welk dagschema

   Variantwissel volgt `juizs:variant-change` (dispatch uit de buy-box).

   Metaveld-contract (Terry 29-07):
     juizs.ingredients → [["gembersap", 25], ["appelsap", 65]]
                         getal = percentage; een string wordt letterlijk
                         overgenomen (bv. "spoortje").
     juizs.nutrition   → [["Energie", "110 kcal"], ["Vezels", "1,2 g"]]
     juizs.allergens   → vrije tekst
   Leeg → het sapje blijft zichtbaar, met een wachttekst in plaats van
   lege lijsten.
   ===================================================================== */
(function () {
  'use strict';

  function init() {
    var root = document.querySelector('[data-juizs-imodal]');
    if (!root || typeof window.JuizsOverlay !== 'function') return;

    var overlay = new window.JuizsOverlay(root);

    var TYPE_ORDER = ['juice', 'smoothie', 'shot', 'veggie'];
    var TYPE_LABEL = { juice: 'Juice', smoothie: 'Smoothie', shot: 'Shot', veggie: 'Veggie' };

    var el = {
      index: root.querySelector('[data-juizs-imod-index]'),
      bottle: root.querySelector('[data-juizs-imod-bottle]'),
      eyebrow: root.querySelector('[data-juizs-imod-eyebrow]'),
      title: root.querySelector('[data-juizs-imod-title]'),
      portion: root.querySelector('[data-juizs-imod-portion]'),
      ings: root.querySelector('[data-juizs-imod-ings]'),
      ingsWrap: root.querySelector('[data-juizs-imod-ings-wrap]'),
      nutr: root.querySelector('[data-juizs-imod-nutr]'),
      nutrWrap: root.querySelector('[data-juizs-imod-nutr-wrap]'),
      pending: root.querySelector('[data-juizs-imod-pending]'),
      allergens: root.querySelector('[data-juizs-imod-allergens]'),
      note: root.querySelector('[data-juizs-imod-note]'),
      prev: root.querySelector('[data-juizs-imod-prev]'),
      next: root.querySelector('[data-juizs-imod-next]'),
      meta: root.querySelector('[data-juizs-imod-meta]'),
    };

    var EMPTY_TEXT =
      root.getAttribute('data-empty-text') ||
      'Ingrediënten en voedingswaarden van dit sapje staan er binnenkort bij.';

    /* ---- Data-eilanden inlezen ---- */
    var sets = {};
    var setKeys = [];

    Array.prototype.forEach.call(document.querySelectorAll('[data-juizs-juices]'), function (node) {
      var key = node.getAttribute('data-juizs-juices');
      try {
        var parsed = JSON.parse(node.textContent);
        if (Array.isArray(parsed) && parsed.length) {
          sets[key] = parsed;
          setKeys.push(key);
        }
      } catch (err) {
        if (window.console) window.console.warn('[juizs-imodal] onleesbaar dagschema', key, err);
      }
    });

    if (!setKeys.length) return;

    var activeKey = setKeys[0];
    var currentId = null;

    function juices() {
      return sets[activeKey] || [];
    }

    function find(id) {
      var list = juices();
      for (var i = 0; i < list.length; i++) {
        if (list[i].id === id) return list[i];
      }
      return null;
    }

    function indexOf(id) {
      var list = juices();
      for (var i = 0; i < list.length; i++) {
        if (list[i].id === id) return i;
      }
      return -1;
    }

    /* ---- Index links opbouwen ---- */
    function typeOf(juice) {
      return String(juice.type || 'juice').trim().toLowerCase();
    }

    function labelFor(type) {
      if (TYPE_LABEL[type]) return TYPE_LABEL[type];
      return type.charAt(0).toUpperCase() + type.slice(1);
    }

    function renderIndex() {
      if (!el.index) return;
      var list = juices();
      var html = '';

      // Bekende types eerst in vaste volgorde, daarna alles wat het metaveld
      // verder oplevert. Zo verdwijnt een onverwachte waarde nooit stilzwijgend
      // uit de index (29-07).
      var order = TYPE_ORDER.slice();
      list.forEach(function (j) {
        if (order.indexOf(typeOf(j)) === -1) order.push(typeOf(j));
      });

      order.forEach(function (type) {
        var group = list.filter(function (j) {
          return typeOf(j) === type;
        });
        if (!group.length) return;

        html +=
          '<details class="juizs-imod-group" open>' +
          '<summary class="juizs-imod-group-head">' +
          '<span class="juizs-imod-group-label">' +
          labelFor(type) +
          '</span>' +
          '<span class="juizs-imod-group-count">(' +
          group.length +
          ')</span>' +
          '</summary><ul class="juizs-imod-group-list">';

        group.forEach(function (j) {
          html +=
            '<li><button type="button" class="juizs-imod-item" data-imod-goto="' +
            escapeAttr(j.id) +
            '">' +
            '<span class="juizs-imod-dot" style="background:' +
            escapeAttr(j.color || '#8fdfb3') +
            '" aria-hidden="true"></span>' +
            '<span class="juizs-imod-item-name">' +
            escapeHtml(j.name) +
            '</span></button></li>';
        });

        html += '</ul></details>';
      });

      el.index.innerHTML = html;
    }

    function syncIndex() {
      if (!el.index) return;
      Array.prototype.forEach.call(el.index.querySelectorAll('[data-imod-goto]'), function (btn) {
        var on = btn.getAttribute('data-imod-goto') === currentId;
        btn.classList.toggle('is-current', on);
        if (on) {
          btn.setAttribute('aria-current', 'true');
        } else {
          btn.removeAttribute('aria-current');
        }
      });
    }

    /* ---- Hulpjes ---- */
    function escapeHtml(value) {
      return String(value == null ? '' : value).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    function escapeAttr(value) {
      return escapeHtml(value);
    }

    function rows(pairs, isPercentage) {
      return (pairs || [])
        .filter(function (pair) {
          return Array.isArray(pair) && pair.length >= 1;
        })
        .map(function (pair) {
          var name = pair[0];
          var value = pair.length > 1 ? pair[1] : '';
          if (isPercentage && typeof value === 'number') value = value + '%';
          return (
            '<li><span>' +
            escapeHtml(name) +
            '</span><span class="juizs-imod-v">' +
            escapeHtml(value) +
            '</span></li>'
          );
        })
        .join('');
    }

    function hasRows(pairs) {
      return Array.isArray(pairs) && pairs.length > 0;
    }

    /* ---- Vullen ---- */
    function populate(id) {
      var juice = find(id);
      if (!juice) return;
      currentId = id;

      if (el.bottle) {
        el.bottle.style.background =
          'linear-gradient(180deg, ' +
          (juice.color || '#8fdfb3') +
          ' 0%, ' +
          (juice.colorDeep || '#3da381') +
          ' 100%)';
        var short = juice.type === 'shot' || juice.type === 'veggie';
        el.bottle.classList.toggle('is-short', short);
      }

      var type = typeOf(juice);
      if (el.eyebrow) {
        var bits = [labelFor(type)];
        if (juice.note) bits.push(juice.note);
        if (juice.moment) bits.push('moment ' + juice.moment);
        el.eyebrow.textContent = bits.join(' · ');
        el.eyebrow.className = 'juizs-imod-eyebrow type-' + type;
      }

      if (el.title) el.title.textContent = juice.name;

      if (el.portion) {
        var meta = [];
        if (juice.time) meta.push(juice.time);
        if (juice.portion) meta.push(juice.portion);
        meta.push('koudgeperst');
        el.portion.textContent = meta.join(' · ');
      }

      var ings = hasRows(juice.ingredients);
      var nutr = hasRows(juice.nutrition);

      if (el.ings) el.ings.innerHTML = ings ? rows(juice.ingredients, true) : '';
      if (el.nutr) el.nutr.innerHTML = nutr ? rows(juice.nutrition, false) : '';
      if (el.ingsWrap) el.ingsWrap.hidden = !ings;
      if (el.nutrWrap) el.nutrWrap.hidden = !nutr;

      /* Leeg metaveld: sapje blijft staan, wachttekst in plaats van
         lege lijsten (afspraak Terry 29-07). */
      if (el.pending) {
        el.pending.hidden = ings || nutr;
        el.pending.textContent = EMPTY_TEXT;
      }

      if (el.allergens) {
        el.allergens.innerHTML =
          '<strong>Allergenen:</strong> ' + escapeHtml(juice.allergens || 'Geen bekende allergenen');
      }

      if (el.note) {
        var showNote = !!juice.note && !!juice.time;
        el.note.hidden = !showNote;
        el.note.textContent = juice.note || '';
      }

      var idx = indexOf(id);
      var total = juices().length;
      if (el.prev) el.prev.disabled = idx <= 0;
      if (el.next) el.next.disabled = idx >= total - 1;
      if (el.meta) {
        var schemaLabel = root.getAttribute('data-schema-label');
        el.meta.textContent =
          'Sap ' + (idx + 1) + ' van ' + total + (schemaLabel ? ' · ' + schemaLabel + ' dagschema' : '');
      }

      syncIndex();
    }

    function navigate(direction) {
      var idx = indexOf(currentId);
      var next = idx + direction;
      if (idx === -1 || next < 0 || next >= juices().length) return;
      populate(juices()[next].id);
    }

    function open(id, opener) {
      renderIndex();
      populate(id || juices()[0].id);
      overlay.open(opener);
    }

    /* ---- Bindingen ---- */
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-juizs-juice]');
      if (trigger) {
        e.preventDefault();
        var variant = trigger.getAttribute('data-juizs-juice-variant');
        if (variant && sets[variant]) activeKey = variant;
        open(trigger.getAttribute('data-juizs-juice'), trigger);
        return;
      }

      var goto = e.target.closest('[data-imod-goto]');
      if (goto && root.contains(goto)) {
        e.preventDefault();
        populate(goto.getAttribute('data-imod-goto'));
      }
    });

    if (el.prev) {
      el.prev.addEventListener('click', function () {
        navigate(-1);
      });
    }
    if (el.next) {
      el.next.addEventListener('click', function () {
        navigate(1);
      });
    }

    document.addEventListener('keydown', function (e) {
      if (!overlay.isOpen) return;
      if (e.key === 'ArrowLeft') navigate(-1);
      else if (e.key === 'ArrowRight') navigate(1);
    });

    /* Buy-box wisselt van variant → ander dagschema, dus een andere set. */
    document.addEventListener('juizs:variant-change', function (e) {
      var id = e.detail && e.detail.variantId ? String(e.detail.variantId) : null;
      if (id && sets[id]) activeKey = id;
    });
  }

  // Vangnet: juizs-cart.js levert window.JuizsOverlay. Staat die (nog) niet
  // klaar — bijvoorbeeld omdat de scriptvolgorde ooit wijzigt — dan wachten we
  // op DOMContentLoaded; op dat moment zijn alle defer-scripts binnen.
  if (typeof window.JuizsOverlay === 'function') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
